export enum ModalDialogModifier {
  WITH_NAVIGATION = 'with-navigation',
  POP_UP = 'pop-up',
  SLIDER_IN_POP_UP = 'slider-in-pop-up',
  WIDE = 'wide',
  MEDIUM = 'medium',
  HIGH = 'high',
}
